import { c as _c } from "react/compiler-runtime";
import { reaction } from 'mobx';
import { useEffect } from 'react';
import { appPreferencesStore } from './appPreferencesStore';
const CSS_VAR = '--background-opacity';
function applyUiBackgroundOpacity(opacity: number): void {
  document.documentElement.style.setProperty(CSS_VAR, String(opacity));
}

/**
 * Applies the user's stored panel background opacity to the document root CSS variable
 * and keeps it in sync with `appPreferencesStore.uiBackgroundOpacity` via a MobX reaction.
 *
 * SSR-safe: document access happens only inside `useEffect`.
 * Can be called from non-observer components — reactivity is handled internally.
 */
export function useUiBackgroundOpacity() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
}
function _temp2() {
  applyUiBackgroundOpacity(appPreferencesStore.uiBackgroundOpacity);
  return reaction(_temp, applyUiBackgroundOpacity);
}
function _temp() {
  return appPreferencesStore.uiBackgroundOpacity;
}